import { render, staticRenderFns } from "./messageDetail.vue?vue&type=template&id=c112d1f8"
import script from "./messageDetail.vue?vue&type=script&lang=js"
export * from "./messageDetail.vue?vue&type=script&lang=js"
import style0 from "./messageDetail.vue?vue&type=style&index=0&id=c112d1f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports